function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import styleFactory from './row-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var RowButton = _ref => {
  var label = _ref.label,
    title = _ref.title,
    onClick = _ref.onClick,
    _ref$leftIcon = _ref.leftIcon,
    leftIcon = _ref$leftIcon === void 0 ? ___EmotionJSX("div", null) : _ref$leftIcon,
    rightIcon = _ref.rightIcon,
    _ref$colours = _ref.colours,
    colours = _ref$colours === void 0 ? {} : _ref$colours,
    collapse = _ref.collapse,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    className = _ref.className,
    _ref$rightIconSize = _ref.rightIconSize,
    rightIconSize = _ref$rightIconSize === void 0 ? 'small' : _ref$rightIconSize,
    _ref$hasPadding = _ref.hasPadding,
    hasPadding = _ref$hasPadding === void 0 ? true : _ref$hasPadding;
  var passive = !onClick;
  var styles = styleFactory(_objectSpread(_objectSpread({}, colours), {}, {
    rightIconSize,
    passive,
    selected,
    hasLeftIcon: Boolean(leftIcon),
    hasPadding
  }));
  return ___EmotionJSX("button", {
    className: className,
    type: "button",
    onClick: onClick,
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.infoContainer
  }, leftIcon && ___EmotionJSX("div", {
    css: styles.leftIcon
  }, leftIcon), ___EmotionJSX("span", {
    css: styles.title
  }, title), ___EmotionJSX("div", {
    css: styles.rightIcon
  }, rightIcon)), (label || !collapse) && ___EmotionJSX("div", {
    css: styles.label
  }, label));
};
export default RowButton;